import axios from 'axios'
import { apiObject } from './apiobject'

const casetype = {
    ...apiObject,
    url: '/userforms/casetypes/',
    icon(id) {
      return `${axios.defaults.baseURL}${this.url}${id}/icon/`
    },
    addChecklistItem (caseTypeId, obj) {
      return new Promise((resolve, reject) => {
        axios.post(`${this.url}${caseTypeId}/checklist/`, obj)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    updateChecklistItem (caseTypeId, obj) {
      return new Promise((resolve, reject) => {
        axios.patch(`${this.url}${caseTypeId}/checklist/${obj.id}/`, obj)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    deleteChecklistItem (caseTypeId, objId) {
      return new Promise((resolve, reject) => {
        axios.delete(`${this.url}${caseTypeId}/checklist/${objId}/`)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
}

const cases = {
    ...apiObject,
    url: '/userforms/cases/',
    downloadCSV ({ search, ordering, filter = {} } = {}) {
      var paramObject = Object.assign({ search, ordering }, filter)
      return axios.get(`${this.url}csv/`, {
        params: paramObject,
        responseType: 'arraybuffer'
      })
    },
    addUserForm (obj, formTemplateId, form_number = '', party_name = '', tags = []) {
      return new Promise((resolve, reject) => {
        axios.post(`${this.url}${obj.id}/userforms/`, { formtemplate_id: formTemplateId, party_name, form_number, tags })
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    changeCasetype (obj) {
      return new Promise((resolve, reject) => {
        axios.patch(`${this.url}${obj.id}/changecasetype/`, {new_casetype_id: obj.case_type.id})
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    updateProgress (obj, checklistitem_id, value) {
      return new Promise((resolve, reject) => {
        axios.patch(`${this.url}${obj.id}/update_progress/`, {checklistitem_id: checklistitem_id, value: value})
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    }
}

export default {
    casetype,
    cases
}